import { useState, useMemo, useEffect } from "react";
import { Dropdown } from "primereact/dropdown";

export default function Pagination({
  data = [],
  loading = false,
  currentData,
  onPageChange,
  onPageSizeChange,
  initialPageSize,
  pageSizeOptions = [20, 50, 100, 1000],
  children, // qualquer extra (como os totais que você mostrou)
}) {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(initialPageSize ?? pageSizeOptions[0]);

  const totalPages = Math.max(1, Math.ceil(data.length / pageSize));

  const paginatedData = useMemo(() => {
    const start = (page - 1) * pageSize;
    return data.slice(start, start + pageSize);
  }, [data, page, pageSize]);

  // expor os dados da página para o pai
  if (currentData) {
    currentData(paginatedData);
  }

  useEffect(() => {
    setPage(1);
  }, [data.size])

  const goToPage = (newPage) => {
    if (newPage < 1 || newPage > totalPages) return;
    setPage(newPage);
    onPageChange && onPageChange(newPage);
  };

  const handlePageSizeChange = (size) => {
    setPageSize(size);
    setPage(1); // resetar para página 1
    onPageSizeChange && onPageSizeChange(size);
  };

  const startIndex = (page - 1) * pageSize;
  const endIndex = Math.min(startIndex + pageSize, data.length);

  return (
      <div className="px-1 flex flex-wrap justify-between items-center gap-3">
        <div className="text-sm text-gray-700">
          {loading ?
            <div className="animate-pulse space-y-4">
              <div className="h-4 bg-muted rounded w-24"></div>
            </div>
            :
            <span>
              Mostrando <strong className="text-foreground font-medium">{startIndex + 1}-{endIndex}</strong> de{" "}
              <strong className="text-foreground font-medium">{data.length}</strong> registros
            </span>
          }
        </div>
        <div className="flex items-center gap-2">
          <div className="flex items-center gap-2">
            <Dropdown
              options={pageSizeOptions}
              value={pageSize}
              onChange={(e) => handlePageSizeChange(e.target.value)}
              className="h-9 items-center"
            />
          </div>
          <div className="flex items-center gap-1">
            <button
              onClick={() => goToPage(1)}
              disabled={page === 1}
              className="w-8 h-8 flex items-center justify-center border border-input rounded-md text-sm text-gray-700 disabled:opacity-50 hover:bg-muted hover:text-foreground transition-colors"
            >
              «
            </button>
            <button
              onClick={() => goToPage(page - 1)}
              disabled={page === 1}
              className="w-8 h-8 flex items-center justify-center border border-input rounded-md text-sm text-gray-700 disabled:opacity-50 hover:bg-muted hover:text-foreground transition-colors"
            >
              ‹
            </button>

            <span className="min-w-8 h-8 px-2 flex items-center justify-center bg-primary text-primary-foreground text-sm font-medium rounded-md">
              {page}
            </span>

            <button
              onClick={() => goToPage(page + 1)}
              disabled={page === totalPages}
              className="w-8 h-8 flex items-center justify-center border border-input rounded-md text-sm text-gray-700 disabled:opacity-50 hover:bg-muted hover:text-foreground transition-colors"
            >
              ›
            </button>
            <button
              onClick={() => goToPage(totalPages)}
              disabled={page === totalPages}
              className="w-8 h-8 flex items-center justify-center border border-input rounded-md text-sm text-gray-700 disabled:opacity-50 hover:bg-muted hover:text-foreground transition-colors"
            >
              »
            </button>
          </div>
        </div>
        {children && <div className="col-12 col-md-9 text-sm text-gray-700 p-0">{children}</div>}

      </div>

  );
}